module.exports = __webpack_public_path__ + "img/ListenandPractice-bg.db9aebcf.png";